import { camelObjectToSnakeObject, filterValueToQuery } from '@/api';

export default function store(axios: any) {
  interface StoreInput {
    name?: string;
    redirectUrl?: string;
    active?: boolean;
    favorite?: boolean;
    image?: string;
    order?: number;
  }

  async function newStore(payload: StoreInput) {
    const response = await axios.post('/store', camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/store] newStore Error', e);
    }
    return null;
  }

  async function getStores(filter: any = {}) {
    try {
      const response = await axios.get(`/store?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/store] getStores Error', e);
    }
    return null;
  }

  async function getStore(id: number) {
    try {
      const response = await axios.get(`/store/${id}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/store] getStore Error', e);
    }
    return null;
  }

  async function updateStore(id: number, payload: StoreInput) {
    try {
      const response = await axios.put(`/store/${id}`, camelObjectToSnakeObject(payload));
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/store] updateStore Error', e);
    }
    return null;
  }

  async function deleteStore(id: number) {
    try {
      const response = await axios.delete(`/store/${id}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/store] deleteStore Error', e);
    }
    return null;
  }

  async function deleteStoreImage(id: number) {
    try {
      const response = await axios.delete(`/store/${id}/image`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/store] deleteStoreImage Error', e);
    }
    return null;
  }

  return {
    newStore,
    getStores,
    getStore,
    updateStore,
    deleteStore,
    deleteStoreImage,
  };
}
